import km from 'keymirror'
import _ from 'underscore'

//TMR ==> ToManyRequests
export default _.extend({}, km({

  CART_GET_TOTAL_START: null,
  CART_GET_TOTAL_SUCCESS: null,
  CART_GET_TOTAL_ERROR: null,
  CART_GET_TOTAL_ERROR_EMPTY: null,
  CART_GET_TOTAL_ERROR_TMR: null,

  CART_GET_SKU_START: null,
  CART_GET_SKU_SUCCESS: null,
  CART_GET_SKU_ERROR: null,
  CART_GET_SKU_ERROR_EMPTY: null,
  CART_GET_SKU_ERROR_TMR: null,

  CART_DELETE_SKU_START: null,
  CART_DELETE_SKU_SUCCESS: null,
  CART_DELETE_SKU_ERROR: null,
  CART_DELETE_SKU_ERROR_EMPTY: null,
  CART_DELETE_SKU_ERROR_TMR: null,

  CART_LOCAL_STORAGE_LIST: null,

  SKU_GET_DETAIL_BY_ID_SUCCESS: null,
  SKU_GET_DETAIL_BY_ID_ERROR: null,
  SKU_GET_DETAIL_BY_ID_ERROR_EMPTY: null,

  CART_ADD_SKU_AGAIN: null,
  CART_DEFAULT_SELECTED_LIST: null,
  CART_SET_TEMP_COUNT_BEFORE_LOGIN: null,
  CART_VERIFY_AFTER_LOGIN: null,
}))
